import { use, useMemo } from "react";
import { CalendarItemStateContext } from "@domain/context/CalendarItemStateContext";
import { useTaxDeadlineEvents } from "./useTaxDeadlineEvents";
import { useUserCalendarEvents } from "./useUserCalendarEvents";
import { overlayItemState } from "./calendarItemState";
import { type CalendarEvent } from "./types";

// SP4 (FIBU-22): the full merged CalendarEvent[] pipeline - derived tax
// deadlines + SP1 user events, overlaid with SP3 per-item state - with NO
// horizon/grouping applied. Extracted out of useHomeCalendar.ts so the
// dedicated calendar page (CalendarPageView, month grid + Agenda tab) can
// consume the exact same merge the widget uses, instead of re-deriving it;
// useHomeCalendar keeps its horizon-capped/grouped widget-specific view on
// top of this.
export const useMergedCalendarEvents = (): CalendarEvent[] => {
    const derivedEvents = useTaxDeadlineEvents();
    const userEvents = useUserCalendarEvents();
    const { stateByKey } = use(CalendarItemStateContext);
    return useMemo(
        () => overlayItemState([...derivedEvents, ...userEvents], stateByKey),
        [derivedEvents, userEvents, stateByKey],
    );
};
